import Description from "./description";
export default Description;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/description/index.ts
// module id = IUL9
// module chunks = 2